import { render } from "./list.vue?vue&type=template&id=bbc84d3c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=bbc84d3c&lang=scss&rel=stylesheet%2Fscss&scoped=true"
script.render = render
script.__scopeId = "data-v-bbc84d3c"

export default script